import { NgModule } from "@angular/core";
import { EudatePipe } from "./eudate/eudate";
import { HttpsPipe } from "./https/https";
import { NlPipe } from "./nl/nl";
import { ReplacePipe } from "./replace/replace";

@NgModule({
  declarations: [EudatePipe, HttpsPipe, NlPipe, ReplacePipe],
  imports: [],
  exports: [EudatePipe, HttpsPipe, NlPipe, ReplacePipe],
})
export class PipesModule {
  public static forRoot() {
    return {
      ngModule: PipesModule,
      providers: [],
    };
  }
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts